import { PROJECTS } from "../../data/projects";
import "./Portfolio.css";

const external = { target: "_blank", rel: "noreferrer" };

function ProjectCard({ project }) {
  const { image, title, summary, stack, github, demo } = project;

  return (
    <article className="portfolio__item">
      <div className="portfolio__item-image">
        <img src={image} alt={title} loading="lazy" />
      </div>
      <div className="portfolio__item-main">
        <h3>{title}</h3>
        <p className="portfolio__summary text-light">{summary}</p>
        <ul className="portfolio__tags" aria-label="Technologies used">
          {stack.map((tech) => (
            <li key={tech} className="tag">
              {tech}
            </li>
          ))}
        </ul>
        <div className="portfolio__item-cta">
          <a href={github} className="btn btn-primary" {...external}>
            View code
          </a>
          {demo && (
            <a href={demo} className="btn" {...external}>
              Live demo
            </a>
          )}
        </div>
      </div>
    </article>
  );
}

export default function Portfolio() {
  return (
    <section id="work" className="portfolio">
      <h5>Portfolio</h5>
      <h2>Projects</h2>
      <p className="section__lead">
        Production-style work highlighted on my resume — full-stack messaging and
        machine learning OCR, with code and documentation on GitHub.
      </p>

      <div className="portfolio__panel">
        <div className="portfolio__list">
          {PROJECTS.map((project) => (
            <ProjectCard key={project.id} project={project} />
          ))}
        </div>
      </div>
    </section>
  );
}
